var UserPasswordAuthProvider = (function () {
    function UserPasswordAuthProvider() {
    }
    UserPasswordAuthProvider.TYPE = "local-userpass";
    UserPasswordAuthProvider.DEFAULT_NAME = "local-userpass";
    return UserPasswordAuthProvider;
}());
export default UserPasswordAuthProvider;
//# sourceMappingURL=UserPasswordAuthProvider.js.map